import { Link } from 'react-router-dom'

import { Button } from '@/shared/components'
import { Alert, FormLabel, styled } from '@mui/material'

export const StyledLogin = styled('main')`
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: ${props => props.theme.palette.background.default};

  ${props => props.theme.breakpoints.up('sm')} {
    height: 100vh;
  }
`

export const StyledForm = styled('form')`
  width: 100%;
  display: flex;
  flex-direction: column;
`

export const StyledLink = styled(Link)`
  color: ${props => props.theme.palette.text.primary};
  font-family: ${props => props.theme.typography.fontFamily};
  font-size: ${props => props.theme.typography.pxToRem(14)};
  margin-top: ${props => props.theme.typography.pxToRem(12)};
  text-align: right;
  cursor: pointer;

  ${props => props.theme.breakpoints.up('md')} {
    margin-top: ${props => props.theme.typography.pxToRem(4)};
  }

  &:hover {
    color: ${props => props.theme.palette.custom.link.color};
  }
`

export const StyledSubmitButton = styled(Button)`
  margin-top: ${props => props.theme.typography.pxToRem(16)};

  ${props => props.theme.breakpoints.up('md')} {
    margin-top: ${props => props.theme.typography.pxToRem(28)};
  }
`

export const StyledAlert = styled(Alert)`
  align-self: stretch;
  margin-bottom: ${props => props.theme.typography.pxToRem(16)};
`

export const StyledTextFieldLabel = styled(FormLabel)`
  margin-top: ${props => props.theme.typography.pxToRem(16)};
`
